import { Badge } from 'antd';
import { Tooltip } from 'farmhub-ui-core';

import { theme } from 'styled';

import { CTag } from './styles';

interface EntityTagProps {
  tooltipContent?: React.ReactNode;
  name?: string | React.ReactNode;
  active?: boolean;
  quantity?: number;
  icon?: React.ReactNode;
  margin?: number;
  height?: string;
  borderRadius?: string;
  size?: 'small' | 'default' | undefined;
  offset?: [number, number];
  onClick?: (e: any) => void;
}

const EntityTag = ({
  tooltipContent,
  name,
  quantity,
  icon,
  active,
  margin = 14,
  height,
  borderRadius,
  size = 'default',
  offset,
  onClick,
}: EntityTagProps): JSX.Element => (
  <CTag
    borderRadius={borderRadius}
    color={active ? theme.colors.primary.main : undefined}
    height={height}
    icon={icon}
    margin={margin}
    onClick={onClick}
  >
    <Tooltip title={tooltipContent}>
      <span className="span text">{name}</span>
    </Tooltip>
    <Badge count={quantity} size="small" />
  </CTag>
);

export default EntityTag;
